/**
 * @generated SignedSource<<d5ecd0bdb0e1e4e7525aff9f444eafcb>>
 * @relayHash 3563e2678c4f0230602a4caec9253cda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecommendationTileFeedFollowRecommendationMutation$variables = {
  followSpace?: ReadonlyArray<AGG$Long | null | undefined> | null | undefined;
  followUser?: ReadonlyArray<string | null | undefined> | null | undefined;
  unfollowSpace?: ReadonlyArray<AGG$Long | null | undefined> | null | undefined;
  unfollowUser?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type RecommendationTileFeedFollowRecommendationMutation$data = {
  readonly setFeedUserConfig: {
    readonly success: boolean;
  } | null | undefined;
};
export type RecommendationTileFeedFollowRecommendationMutation = {
  response: RecommendationTileFeedFollowRecommendationMutation$data;
  variables: RecommendationTileFeedFollowRecommendationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSpace"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unfollowSpace"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unfollowUser"
},
v4 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "followSpaces",
            "variableName": "followSpace"
          },
          {
            "kind": "Variable",
            "name": "followUsers",
            "variableName": "followUser"
          },
          {
            "kind": "Variable",
            "name": "unfollowSpaces",
            "variableName": "unfollowSpace"
          },
          {
            "kind": "Variable",
            "name": "unfollowUsers",
            "variableName": "unfollowUser"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SetFeedUserConfigPayload",
    "kind": "LinkedField",
    "name": "setFeedUserConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RecommendationTileFeedFollowRecommendationMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecommendationTileFeedFollowRecommendationMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "3563e2678c4f0230602a4caec9253cda",
    "id": "cac7c289c3f4e25bbc8fb98e9fe298c45cebf49bbc802f65013db2a336151d8d",
    "metadata": {},
    "name": "RecommendationTileFeedFollowRecommendationMutation",
    "operationKind": "mutation",
    "text": "mutation RecommendationTileFeedFollowRecommendationMutation($followUser:[ID],$followSpace:[Long],$unfollowUser:[ID],$unfollowSpace:[Long]){setFeedUserConfig(input:{followUsers:$followUser,followSpaces:$followSpace,unfollowUsers:$unfollowUser,unfollowSpaces:$unfollowSpace}){success}}"
  }
};
})();

(node as any).hash = "1a44a6518af9b607fdb62610585fe24e";

export default node;
